import { BoxContainer, LoadingDots, LoadingDotsContainer, LoadingLabel } from './LoadingText.style';
import { FunctionalComponent, h } from 'preact';

type LoadingDotsProps = {
  text?: string;
};

export const LoadingText: FunctionalComponent<LoadingDotsProps> = ({ text = '' }) => (
  <BoxContainer>
    {text && <LoadingLabel>{text}</LoadingLabel>}
    <LoadingDotsContainer>
      <LoadingDots />
    </LoadingDotsContainer>
  </BoxContainer>
);
